import { Anchor, Box, Flex, Text, useMantineTheme } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

import type { IConversionResultMessage } from '../../../types';
import { getCookie, setAccessToken, setRefreshToken } from '../../../../../../../../../shared/cookie';

interface IManualSuccessBoxProps {
  message: IConversionResultMessage;
  fileName?: string;
  href?: string;
}

export default function ManualSuccessBox({ message, fileName, href }: IManualSuccessBoxProps) {
  const theme = useMantineTheme();
  const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

  const handleClickLink = () => {
    const authorizationCookie = getCookie('Authorization');
    const refreshTokenCookie = getCookie('RefreshToken');

    if (!authorizationCookie || !refreshTokenCookie) return;

    const cookieOptions = cookieDomain ? { domain: cookieDomain, path: '/docs/api' } : { path: '/docs/api' };

    setAccessToken(authorizationCookie, cookieOptions);
    setRefreshToken(refreshTokenCookie, cookieOptions);
  };

  return (
    <Box
      p="md"
      style={(theme) => ({
        borderRadius: theme.radius.sm,
        border: `1px solid ${theme.colors.green[5]}`,
        backgroundColor: theme.colors.green[0],
      })}
    >
      <Text fw={500} mb={4}>
        {fileName}
      </Text>
      <Text size="sm" c="success" mb="lg">
        {message.title}
      </Text>
      <Flex gap={4} mb={8}>
        <IconAlertCircle size={16} color={theme.colors.green[5]} style={{ marginTop: 4 }} />
        <Box>
          {message.descriptions.map((line) => (
            <Text key={line} size="sm" c="success" lh={2}>
              {line}
            </Text>
          ))}
          <Anchor href={href} target="_blank" onClick={handleClickLink}>
            {href}
          </Anchor>
        </Box>
      </Flex>
    </Box>
  );
}
